import * as React from "react";
import { useDispatch, useSelector } from "react-redux";

import { WidgetIframe } from "components/application-widget";
import { getFullscreenWidgets } from "store/entities/applications/selectors";
import { getLoadedFullscreenWidgets } from "store/features/applications/selectors";
import { FullscreenWidgetsViewActions } from "store/views/fullscreen-widgets/actions";

import { containerStyles } from "./styles";

export interface IProps {
  visibleWidgetSlugOrId: string | null;
}

const FullscreenWidgets: React.FC<IProps> = ({ visibleWidgetSlugOrId }) => {
  const dispatch = useDispatch();
  const widgets = useSelector(getFullscreenWidgets);
  const loadedWidgetsIds = useSelector(getLoadedFullscreenWidgets);

  const loadedWidgets = React.useMemo(
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    () => widgets.filter((widget: any) => loadedWidgetsIds.includes(widget.id)),
    [widgets, loadedWidgetsIds]
  );

  const visibleWidgetId = React.useMemo(() => {
    const widgetFound = widgets.find(
      // FIXME: Fix this the next time the file is edited.
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (widget: any) => widget.appSlug === visibleWidgetSlugOrId || widget.appId === visibleWidgetSlugOrId
    );
    if (!widgetFound) {
      return null;
    }

    return widgetFound.id;
  }, [visibleWidgetSlugOrId, widgets]);

  React.useEffect(() => {
    if (visibleWidgetId !== null) {
      dispatch(FullscreenWidgetsViewActions.load({ id: visibleWidgetId }));
    }
  }, [visibleWidgetId, dispatch]);

  return (
    <>
      {/* TODO: Fix this the next time the file is edited. */}
      {/* eslint-disable-next-line @typescript-eslint/no-explicit-any */}
      {loadedWidgets.map((widget: any) => (
        <div key={widget.id} css={containerStyles(visibleWidgetId === widget.id)}>
          <WidgetIframe widget={widget} />
        </div>
      ))}
    </>
  );
};

export default FullscreenWidgets;
